export const createSavingsOpportunityViewFixedCacheKey =
  "postUsersMeOrganisationsCurrentOpportunityViews-fixed-cache-key";

export const updateSavingsOpportunityViewFixedCacheKey =
  "patchUsersMeOrganisationsCurrentOpportunityViewsByViewId-fixed-cache-key";

export const deleteSavingsOpportunityViewFixedCacheKey =
  "deleteUsersMeOrganisationsCurrentOpportunityViewsByViewId-fixed-cache-key";
